import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-datatable-footer',
  templateUrl: './app-datatable-footer.component.html',
  styleUrls: ['./app-datatable-footer.component.scss']
})
export class AppDatatableFooterComponent implements OnInit {
  @Input() table: DatatableComponent;
  @Output() change = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  lastItemOffset() {
    if (!this.table) {
      return 0;
    }

    return Math.min((this.table.offset + 1) * this.table.pageSize, this.table.rowCount);
  }
}
